import React, { useState, useEffect } from 'react'

import Navbar from '../../Components/Navbar/Navbar'
import { nationalities } from '../../Utils/Common';
import toast from 'react-hot-toast';

import { 
    Layout,
    Col, 
    Row,
    Button,
    Space,
    Select,
    Input,
    Table,
    DatePicker,
} from 'antd';
import { UseGetRequest } from '../../Utils/api/ApiRequests'
// import { usePostRequest } from '../../hooks/usePostRequest'

const { RangePicker } = DatePicker;
const { Option } = Select;
const { Search } = Input;

const MemberReport = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [pageSize, setPageSize] = useState('');
    const [reportData, setReportDate] = useState([])
    const [filterConfig, setFilterConfig] = useState({
        term: '',
        status: '',
        gender: '',
        nationality: '',
        dependents: '',
        corporate_id: '',
        page: 1,
    })
    const status = [
        {
            value: '',
            label: 'All',
        },
        {
            value: 'Active',
            label: 'Active',
        },
        {
            value: 'Inactive',
            label: 'Inactive',
        },
        {
            value: 'Deferred',
            label: 'Deferred',
        },
        {
            value: 'Cancelled',
            label: 'Cancelled',
        },
        {
            value: 'Delinquent',
            label: 'Delinquent',
        },
        {
            value: 'Pending',
            label: 'Pending',
        },
        {
            value: 'Assigned',
            label: 'Assigned',
        },
        {
            value: 'Transferred',
            label: 'Transferred',
        },
        {
            value: 'Resigned',
            label: 'Resigned',
        },
        {
            value: 'Expelled',
            label: 'Expelled',
        },
        {
            value: 'Suspended',
            label: 'Suspended',
        },
        {
            value: 'Stop Billing',
            label: 'Stop Billing',
        },
        {
            value: 'Leave Of Absence',
            label: 'Leave Of Absence',
        },
        {
            value: 'For Legal',
            label: 'For Legal',
        },
    ]

    const gender = [
        {
            value: '',
            label: 'All',
        },
        {
            value: 'male',
            label: 'Male',
        },
        {
            value: 'female',
            label: 'Female',
        },
    ]

    const defaultColumns = [
        {
            title: 'Customer ID',
            dataIndex: 'ar_cust_id',
            align: 'center',
            key: 'ar_cust_id',
        },
        {
            title: 'Member ID',
            dataIndex: 'member_no',
            align: 'center',
            key: 'member_no',
        },
        {
            title: 'Member',
            dataIndex: 'member_name',
            align: 'center',
            key: 'member_name',
        },
        ...(filterConfig?.dependents === 'spouse' || filterConfig?.dependents === '' ? [{
            title: 'Spouse',
            dataIndex: 'spouse_name',
            align: 'center',
            key: 'spouse_name',
        }] : []),
        ...(filterConfig?.dependents === 'children' || filterConfig?.dependents === '' ? [{
            title: 'Children',
            dataIndex: 'children',
            align: 'center',
            key: 'children',
            render: (_, record) => (
                <div>
                    {record?.childrens?.map((data, index) => (
                        <div key={index}>
                            - <strong>{data?.children_name}</strong>
                        </div>
                    ))}
                </div>
            ),
        }] : []),
    ];
    
    const dependents = [
        {
            value: '',
            label: 'All',
        },
        {
            value: 'spouse',
            label: 'Spouse',
        },
        {
            value: 'children',
            label: 'Children',
        },
    ]

    const member_class = [
        {
            value: '',
            label: 'All',
        },
        {
            value: 'Class A',
            label: 'Class A',
        },
        {
            value: 'Class B',
            label: 'Class B',
        },
        {
            value: 'Founding Members',
            label: 'Founding Members',
        },
        {
            value: 'Honorary Members',
            label: 'Honorary Members',
        },
        {
            value: 'Lot Buyer',
            label: 'Lot Buyer',
        },
        {
            value: 'Assignee Members',
            label: 'Assignee Members',
        },    
    ]
    async function fetchReportData  () {
        setIsLoading(true)
        const response = await UseGetRequest("reports/get_member_report", filterConfig);
        if (response?.data) {
            setReportDate(response?.data?.members);
            setPageSize(response?.data?.size)
        } else {
            setReportDate([])
            setPageSize('')
        }
        setIsLoading(false);
    }

    async function fetchExportExcel() {
        setIsLoading(true)
        const response = await UseGetRequest("reports/create_member_report_excel",filterConfig);
        if (response?.data) {
          const link = document.createElement('a');
          link.href = response.data.url;
          link.setAttribute('download', 'file.xlsx'); // You can specify the file name
          document.body.appendChild(link);
          link.click();
          link.remove();
        } else {
          toast.error(response?.data?.message)
        }
        setIsLoading(false);
    }

    const onSearch = (e) => {
        setFilterConfig((prev) => (
            {
                ...prev,
                term: e.target.value || ''
            }
        ));
    };  

    const onSearchType = (e, name) => {
        setFilterConfig((prev) => (
            { 
                ...prev,
                [name]: e || ''
            }
        ));
    };  


    const handleTableChange = (pagination) => {
        setFilterConfig((prev) => ({
            ...prev,
            page: parseInt(pagination.current),
            page_size: pagination.pageSize
            // total_records_per_page: pagination.pageSize,
        }));
    };

    useEffect(() => {
        fetchReportData();
        // fetchExportData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [filterConfig]);

    return (
        <Layout className='page'>
            <Navbar navKey={'member_report'}/>
            <Layout className='content-container overflow-y custom-padding'>
                <Row className='responsive-tab-inline mb-4'>
                    <Col span={9} className='header-container'>
                        MEMBER REPORT
                    </Col>
                    <Col span={15} className='mt-2 responsive-tab-width' align='end'>
                        <Space className='responsive-inline'> 
                            <RangePicker  
                                style={{width:'100%'}}
                                placeholder={['Date From', 'Date To']}
                                format={'YYYY/MM/DD'}
                                // disabled={isDisabled}
                            />
                            <Button 
                                className='excel-btn' 
                                size="large"
                                onClick={fetchExportExcel}
                            >
                                Export To Excel
                            </Button>
                        </Space>
                    </Col>
                </Row>
                <Row className='mb-4'>
                    <Space span={24} className='responsive-inline excel-row'>
                        <Search
                            placeholder="Search..."
                            size='medium'
                            onChange={(e)=>onSearch(e)}
                            className='responsive-header-input'
                        />                
                        <Select
                            placeholder="Select Status"
                            onChange={(e)=>onSearchType(e,'status')}
                            placement='bottomLeft'
                            className='select-field responsive-header-input'
                            align='left'
                            options={status}
                        />    
                        <Select
                            placeholder="Select Gender"
                            onChange={(e)=>onSearchType(e,'gender')}
                            placement='bottomLeft'
                            className='select-field responsive-header-input'
                            align='left'
                            options={gender}
                        />    
                        <Select 
                            placeholder="Select a Nationality"
                            onChange={(e)=>onSearchType(e,'nationality')}
                            showSearch
                            allowClear
                            filterOption={(input, option) =>
                                option?.children?.toLowerCase().includes(input.toLowerCase())
                            }
                        >
                            {
                                nationalities.map((data) => (
                                    <Option key={data.name} value={data.name}>{data.name}</Option>
                                ))
                            }
                        </Select> 
                        <Select
                            placeholder="Select Class"
                            onChange={(e)=>onSearchType(e, 'class')}
                            placement='bottomLeft'
                            className='select-field responsive-header-input'
                            align='left'
                        >
                            {
                                member_class.map((data) => (
                                    <Option key={data.value} value={data.value}>{data.label}</Option>
                                ))
                            }
                        </Select>  
                       
                        <Select
                            placeholder="Select Dependents"
                            onChange={(e)=>onSearchType(e,'dependents')}
                            placement='bottomLeft'
                            className='select-field responsive-header-input'
                            align='left'
                            options={dependents}
                        />    
                        <Select
                            placeholder="Select Corporate"
                            onChange={(e)=>onSearchType(e, 'corporate_id')}
                            placement='bottomLeft'
                            className='select-field responsive-header-input'
                            align='left'
                            // options={status}
                        />    
                    </Space>
                </Row>
                <Row>
                    <Col span={24} className='responsive-overflow-auto'>
                        <Table
                            bordered
                            dataSource={reportData}
                            columns={defaultColumns}
                            loading={isLoading}
                            tablePages={10}
                            handleTableChange={handleTableChange}
                            filterConfig={filterConfig}
                            totalSize={pageSize}
                            isSearch={true}
                        />
                    </Col>
                </Row>
            </Layout>
        </Layout>
    )
}

export default MemberReport
